// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tour Positioning Fixes
 * Minimal CSS to prevent interference with react-joyride
 */

/* Disable hover transforms during tour to prevent positioning issues */
body.tour-active [class*="DiamondCard"]:hover {
  transform: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/tour-fixes.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,uEAAuE;AACvE;EACE,0BAA0B;AAC5B","sourcesContent":["/**\n * Tour Positioning Fixes\n * Minimal CSS to prevent interference with react-joyride\n */\n\n/* Disable hover transforms during tour to prevent positioning issues */\nbody.tour-active [class*=\"DiamondCard\"]:hover {\n  transform: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
